import React from 'react'
import "./servicios.css"
import {AiOutlineCheck} from "react-icons/ai"


const Servicios = () => {
  return (
    <section id='servicios'>
      <h5>QUE OFRECEMOS</h5>
      <h2>SERVICIOS</h2>

      <div className='container servicies__container'>
        <article className='servicie'>
          <div className='servicie__head'>
            <h3>Desarrollo y mantenimiento de sitios web</h3>
          </div>

          <ul className='servicie__list'>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Desarrollo de páginas web utilizando HTML, CSS y JavaScript</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Diseño de interfaces atractivas y funcionales.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Integración de elementos interactivos y multimedia.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Actualización y mejora de sitios existentes</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Solución de problemas y debugging</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Mantenimiento regular para asegurar la compatibilidad con los navegadores y actualizaciones</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX*/}
        <article className='servicie'>
          <div className='servicie__head'>
            <h3>Desarrollo de aplicaciones móviles</h3>
          </div>

          <ul className='servicie__list'>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Diseño de interfaces de usuario para aplicaciones móviles</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Creación de interfaces intuitivas y atractivas para usuarios móviles.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Implementación de estándares de diseño y usabilidad.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Pruebas y depuración de aplicaciones móviles</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Manejo de bases de datos locales para almacenamiento de datos.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Optimización del rendimiento y la eficiencia de la aplicación</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX*/}
        <article className='servicie'>
          <div className='servicie__head'>
            <h3>Soporte técnico y resolución de problemas</h3>
          </div>

          <ul className='servicie__list'>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Identificación y solución de problemas técnicos.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Diagnóstico de errores y fallos en aplicaciones o sistemas.</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Mantenimiento y actualización de bases de datos</p>
            </li>
            <li>
              <AiOutlineCheck className='servicie__list-icon'/>
              <p>Actualización de estructuras y consultas de base de datos.</p>
            </li>
         
          </ul>
        </article>

        
      </div>

    </section>
  )
}

export default Servicios